import { render, staticRenderFns } from "./ClientShippingModal.vue?vue&type=template&id=b04be2c8&scoped=true"
import script from "./ClientShippingModal.vue?vue&type=script&lang=js"
export * from "./ClientShippingModal.vue?vue&type=script&lang=js"
import style0 from "./ClientShippingModal.vue?vue&type=style&index=0&id=b04be2c8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b04be2c8",
  null
  
)

export default component.exports